import React from 'react';
import styles from './ProjectOrActionTable.module.css';

const getColomnColor = (value) => {
  if (value < 80) return styles.textRed;
  if (value < 95) return styles.textYellow;
  return styles.textGreen;
};

const ProjectOrActionTable = ({ data, isOn }) => {
  if (!Array.isArray(data) || data.length === 0) return null;

  return (
    <div className={`${styles.wrapper} no-scrollbar`}>
      <div style={{ width: "100%"}}>
        <div className={styles.headerCell}></div>
        {data?.[data.length - 1]?.data?.map((item, index) => (
          <div key={index} className={styles.labelCell}>
            {item.type}
          </div>
        ))}
      </div>

      {data.map((item, index) => (
        <div key={index} className={styles.column}>
          {item.isCurrent && (
            <>
              <div className={styles.activeDotWrapper}>
                <div className={styles.activeDot}></div>
              </div>
              <div className={styles.activeOverlay}></div>
            </>
          )}

          <div className={styles.dayCell}>{item.day}</div>

          {item?.data?.map(({ value }, i) =>
            isOn ? (
              <div key={i} className={styles.dataCell}>
                <span className={`${styles.text} ${getColomnColor(Number(value.or))}`}>
                  {value.or}
                </span>
              </div>
            ) : (
              <React.Fragment key={i}>
                <div className={styles.dataHalfCell}>
                  <span className={`${styles.subText}`}>{value.actual}</span>
                </div>
                <div className={styles.dataHalfCell}>
                  <span className={`${styles.subText} ${getColomnColor(Number(value.plan))}`}>
                    {value.plan}
                  </span>
                </div>
              </React.Fragment>
            )
          )}
        </div>
      ))}
    </div>
  );
};

export default ProjectOrActionTable;
